import { render, staticRenderFns } from "./TableStatWebmasters.vue?vue&type=template&id=6048abf6&scoped=true&"
import script from "./TableStatWebmasters.vue?vue&type=script&lang=js&"
export * from "./TableStatWebmasters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048abf6",
  null
  
)

export default component.exports